<template>
  <div
    id="growth-wizard-welcome-screen"
    class="gs-welcome-screen"
  >
    <img
      :src="HUBSTAFF_LOGO"
      alt="Hubstaff"
      class="logo"
      width="80"
      height="80"
    />
    <div
      class="title"
      data-testid="gs-welcome-title"
    >
      Manage your team without micromanaging.
    </div>
    <div class="subtitle">
      In just a few minutes, you'll have clear visibility into your team's work — without constant check-ins. Built for
      teams with <strong>virtual assistants</strong>, <strong>contractors</strong>, and <strong>remote employees</strong>.
    </div>
    <img
      :src="GETTING_STARTED_WELCOME_IMG"
      alt="Manage your team without micromanaging"
      class="welcome-image"
    />
    <div
      class="welcome-preview"
      aria-hidden="true"
    >
      <div class="week-strip">
        <div
          v-for="day in WEEK"
          :key="day.date"
          class="day"
        >
          <div class="day-label day-label--full">{{ day.name }}, Aug {{ day.date }}</div>
          <div class="day-label day-label--short">
            <span class="day-name">{{ day.name }}</span>
            <span class="day-date">{{ day.date }}</span>
          </div>
          <div class="day-progress">
            <div
              class="day-progress-fill"
              :style="{ width: `${day.progress}%` }"
            ></div>
          </div>
          <div
            class="day-time"
            :class="{ 'is-empty': !day.activity }"
          >
            {{ day.time }}
          </div>
          <span
            class="day-activity-badge"
            :class="activityBadgeClass(day.activity)"
          >
            {{ day.activity ? `${day.activity}%` : '-' }}
          </span>
        </div>
      </div>
      <div class="member-cards">
        <div
          v-for="member in MEMBERS"
          :key="member.name"
          class="member-card"
        >
          <img
            :src="member.avatar"
            alt=""
            class="member-avatar"
            width="64"
            height="64"
          />
          <div class="member-info">
            <div class="member-name">{{ member.name }}</div>
            <div
              class="member-status"
              :class="{ 'is-working': member.workingOn }"
            >
              <span class="status-icon"></span>
              <template v-if="member.workingOn">
                Working on <strong>{{ member.workingOn }}</strong>
              </template>
              <template v-else>Not working</template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppButton
      type="primary"
      class="continue-button"
      data-testid="gs-welcome-button"
      @click="$emit('start')"
    >
      Get started
    </AppButton>
  </div>
</template>

<script>
import {
  HUBSTAFF_LOGO,
  GETTING_STARTED_WELCOME_IMG,
  GETTING_STARTED_WELCOME_ADRIAN_GOIA,
  GETTING_STARTED_WELCOME_MADELINE_PETERSON,
} from '~/rails_assets';

const LOW_ACTIVITY_THRESHOLD = 50;

// Static preview shown on tablet and mobile, where the desktop illustration doesn't fit.
const WEEK = [
  { name: 'Mon', date: 20, time: '7:25', activity: 51, progress: 75 },
  { name: 'Tue', date: 21, time: '8:01', activity: 66, progress: 75 },
  { name: 'Wed', date: 22, time: '6:40', activity: 36, progress: 50 },
  { name: 'Thu', date: 23, time: '0:00', activity: 0, progress: 0 },
  { name: 'Fri', date: 24, time: '8:18', activity: 71, progress: 100 },
  { name: 'Sat', date: 25, time: '0:00', activity: 0, progress: 0 },
  { name: 'Sun', date: 26, time: '0:00', activity: 0, progress: 0 },
];

const MEMBERS = [
  { name: 'Adrian Goia', avatar: GETTING_STARTED_WELCOME_ADRIAN_GOIA, workingOn: 'Product Design' },
  { name: 'Madeline Peterson', avatar: GETTING_STARTED_WELCOME_MADELINE_PETERSON, workingOn: null },
];

export default {
  name: 'WelcomeScreen',

  emits: ['start'],

  data() {
    return {
      HUBSTAFF_LOGO,
      GETTING_STARTED_WELCOME_IMG,
      WEEK,
      MEMBERS,
    };
  },

  methods: {
    activityBadgeClass(activity) {
      if (!activity) {
        return 'day-activity-badge--empty';
      }

      return activity < LOW_ACTIVITY_THRESHOLD ? 'day-activity-badge--low' : '';
    },
  },
};
</script>
